import type { IPageTagsResources } from "./PageTags.Resources";

export const PageTagsResourcesEn: IPageTagsResources = {
    title: "Tags",
    titleDescription: "flyer brands and products",
};
